import actions from "./actions";

const { FETCH_FORWARD, FETCH_FORWARDS, RESET_FORWARD } = actions;

const initState = {
    forwards: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    forwardTo: { _id: null }
};

const ForwardReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_FORWARDS:
            return {
                ...state,
                forwards: data
            };
        case RESET_FORWARD:
            return {
                ...state,
                forward: initState.forwardTo,
            };
        case FETCH_FORWARD:
            return {
                ...state,
                forwardTo: data,
            };
        default:
            return state;
    }
};

export default ForwardReducer;
